import { render, staticRenderFns } from "./column-edit.vue?vue&type=template&id=a1dd1516&scoped=true&"
import script from "./column-edit.vue?vue&type=script&lang=js&"
export * from "./column-edit.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a1dd1516",
  null
  
)

export default component.exports